/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PRPVCounterPartyTypeMap { 
    counterPartyId: string;
    counterPartyTypeId: string;
    counterPartyTypeName: string;
    counterPartyTypeDescription?: string | null;
    counterPartyName: string;
    counterPartyShortName?: string | null;
    counterPartyDescription?: string | null;
    counterPartiesLogUserId?: string | null;
}

